export default __webpack_public_path__ + "static/media/logo2.a50d47d5.png";